<template>
	<a :href="content.link" class="content-tile" rel="noopener">
		<div class="content-tile__image-wrapper">
			<img
				:src="content.image"
				:alt="content.title"
				class="content-tile__image"
			/>
		</div>
		<div class="content-tile__title">
			<span class="arrow">&rarr;</span> <span v-html="content.title"></span>
		</div>
	</a>
</template>

<script>
export default {
	name: 'ContentTile',
	props: {
		content: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.content-tile {
	display: flex;
	flex-direction: column;
	text-decoration: none;
	position: relative;

	&:hover {
		.content-tile__image-wrapper {
			&:before {
				opacity: 1;
			}
		}

		.content-tile__title {
			padding-left: 15px;
			transition: padding-left 0.2s;

			span {
				&.arrow {
					left: 0;
					transition: left 0.2s;
				}
			}
		}
	}
}
/* .content-tile:hover {
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  transform: translateY(-4px) scale(1.03);
} */
.content-tile__image-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 250px;
	margin-bottom: 24px;
	background: var(--white);
	border-radius: 16px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	padding: 0;
	text-decoration: none;
	transition: box-shadow 0.2s, transform 0.2s;
	width: 100%;
	position: relative;
	overflow: hidden;

	&:before {
		content: 'Learn more →';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background: var(--fpe-blue);
		color: var(--white);
		font-size: 14px;
		font-weight: 300;
		line-height: 18px;
		letter-spacing: 0.3px;
		opacity: 0;
		transition: opacity 0.2s;
		z-index: 1;
	}

	.brand_highlight_slider & {
		min-height: 300px;
	}
}
.content-tile__image {
	height: 250px;
	width: 100%;
	object-fit: cover;

	.brand_highlight_slider & {
		height: 300px;
	}
}
.content-tile__title {
	position: relative;
	overflow: hidden;
	padding-left: 0;
	transition: padding-left 0.2s;

	span {
		color: var(--fpe-blue);
		margin-top: auto;
		text-decoration: none;
		font: normal normal 300 14px/18px var(--primary-font-family);

		&.arrow {
			position: absolute;
			top: 3px;
			left: -15px;
			display: flex;
			justify-content: center;
			transition: left 0.2s;
		}
	}
}
</style> 


// WEBPACK FOOTER //
// resources/assets/scripts/vue/ContentTile.vue